import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ParamsHelper } from 'src/app/helpers/ParamsHelper';
import { resolvePsaCertifierDescription } from 'src/app/helpers/utils/psa-certifier.util';
import { formatFilterDate } from 'src/app/pages/operation/shared/operation-filter.utils';
import { CarbonCredit } from 'src/app/shared/interfaces/carbon-credit';
import { Pagination } from 'src/app/shared/interfaces/pagination';
import { CarbonFilter } from '../characteristic-consult/interfaces/carbon-filter';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(
    private datePipe: DatePipe
  ) { }

  transformDataCarbonCredit(carbonCredit: CarbonCredit[]): CarbonCredit[] {
    try {
      carbonCredit.forEach(carbon => this.transformCarbonCredit(carbon));
      return carbonCredit;
    } catch {
      return [];
    }
  }

  transformCarbonCredit(carbon: CarbonCredit): CarbonCredit {
    carbon.insertDate = this.datePipe.transform(carbon.insertDate, 'dd/MM/yyyy') || '';
    carbon.issueDate = this.datePipe.transform(carbon.issueDate, 'dd/MM/yyyy') || '';
    carbon.vintageStart = this.datePipe.transform(carbon.vintageStart, 'dd/MM/yyyy') || '';
    carbon.vintageEnd = this.datePipe.transform(carbon.vintageEnd, 'dd/MM/yyyy') || '';
    carbon.statusCodeDescription = this.statusCodeParser(carbon.statusCode);
    carbon.certifierDescription = resolvePsaCertifierDescription(
      carbon.serialCode,
      carbon.certifierDescription
    );
    return carbon;
  }

  statusCodeParser(statusCode: string) {
    if (statusCode === 'SUBMITED_ACX') return 'Aguardando confirmação na ACX';
    if (statusCode === 'IF_AG_APROV_B3') return 'Aguardando validação da ACX';
    if (statusCode === 'IF_AG_APRV_OP_DETENTOR') return 'Aguardando aprovação do detentor';
    if (statusCode === 'IF_REJEITADO_POR_OPERACAO') return 'Rejeitado por operação';
    if (statusCode === 'IF_REJEITADO_B3') return 'Rejeitado pela B3';
    if (statusCode === 'CONFIRMED_BY_USER') return 'Confirmado pelo Cliente';
    if (statusCode === 'REJECTED_BY_USER') return 'Rejeitado pelo Cliente';
    if (statusCode === 'REJECTED') return 'Rejeitado pela ACX';
    if (statusCode === 'VERIFIED') return 'Registrado na B3';
    if (statusCode === 'IF_APROVADO') return 'Aprovado';

    return statusCode;
  }


  carbonFilterParams(filters: CarbonFilter, pagination:Pagination<CarbonCredit>): HttpParams {
    return this.carbonConsultFilterParams(filters)
      .setParams('page', (pagination.page + ''))
      .setParams('page-size', (pagination.size + ''))
      .getParams();
  }

  carbonPrintParams(filters: CarbonFilter): HttpParams {
    return this.carbonConsultFilterParams(filters).getParams();
  }

  private carbonConsultFilterParams(filters: CarbonFilter): ParamsHelper {
    return new ParamsHelper(new HttpParams())
      .setParams('initialDate', formatFilterDate(filters.initialDate) || '')
      .setParams('finalDate', formatFilterDate(filters.finalDate) || '')
      .setParams('registerCode', (filters.registerCode || ''))
      .setParams('holderCode', (filters.holderCode || ''))
      .setParams('projectName', (filters.projectName || ''))
      .setParams('externalCode', (filters.externalCode || ''))
      .setParams('carbonCreditCode', (filters.carbonCreditCode || ''))
      .setParams('filterByInsertDate', filters.filterByInsertDate ? 'true' : '');
  }


}
